import { getBaseUrl } from "./baseUrl";
import { authFetch } from "./apiFetch";

/**
 * Same API auth as distribution SQL endpoints: Firebase Bearer token via authFetch;
 * server enforces project ownership (or ADMIN_UID) on distribution_project_id.
 *
 * @param {string} distributionProjectId
 * @param {{ from?: string, to?: string }} [range] - YYYY-MM-DD
 * @returns {Promise<{ estimates: Array, currency?: string, disclaimer?: string, error?: string }>}
 *   `currency` matches server `YOUTUBE_ANALYTICS_CURRENCY` (default INR; revenue field name is still revenue_usd_estimate).
 */
export async function getYoutubeDailyEstimates(
  distributionProjectId,
  range = {}
) {
  const base = getBaseUrl();
  if (!base || !distributionProjectId) {
    return { estimates: [] };
  }
  const params = new URLSearchParams({
    distribution_project_id: distributionProjectId,
  });
  if (range.from) params.set("from", range.from);
  if (range.to) params.set("to", range.to);
  const url = `${base}/youtube-daily-estimates?${params.toString()}`;
  try {
    const res = await authFetch(url);
    if (!res.ok) {
      const t = await res.text();
      console.error("youtube-daily-estimates error", res.status, t);
      return { estimates: [], error: `Request failed (${res.status})` };
    }
    return await res.json();
  } catch (e) {
    console.error("getYoutubeDailyEstimates", e);
    return { estimates: [], error: "Network error" };
  }
}

/**
 * @param {string} distributionProjectId
 * @returns {Promise<{ binding: object | null, error?: string }>}
 */
export async function getYoutubeChannelBinding(distributionProjectId) {
  const base = getBaseUrl();
  if (!base || !distributionProjectId) {
    return { binding: null };
  }
  const params = new URLSearchParams({
    distribution_project_id: distributionProjectId,
  });
  const url = `${base}/youtube-channel-binding?${params.toString()}`;
  try {
    const res = await authFetch(url);
    if (!res.ok) {
      return { binding: null, error: `Request failed (${res.status})` };
    }
    return await res.json();
  } catch (e) {
    console.error("getYoutubeChannelBinding", e);
    return { binding: null, error: "Network error" };
  }
}
